/**
 * Component Registry for The View at Mill Run
 * 
 * Inherits from @vibesites-dolben/theme-rise and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-dolben/theme-rise/registry';
import { AmenitiesList } from './components/AmenitiesList';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { RenovatedApartmentFeatures } from './components/RenovatedApartmentFeatures';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  AmenitiesList,
  Header,
  Hero,
  RenovatedApartmentFeatures,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
